import React from 'react'
import { Tooltip, Button } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'

const CalculatorBackButton = ({ isFree }) => {
    const navigate = useNavigate()
    return (
        <Tooltip title='Back to Calculators Selection'>
            <Button
                style={{ marginRight: '24px' }}
                type='text'
                icon={<ArrowLeftOutlined />}
                onClick={() => {
                    navigate('/home', { state: { isFree, sentFromCalculatorBack: true } })
                }}
            />
        </Tooltip>
    )
}

export default CalculatorBackButton
